module.exports = __webpack_public_path__ + "img/thumb_16.b7b3fa02.jpg";